export default "__VITE_ASSET__C37pziJn__"